import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\LawController::policy
* @see app/Http/Controllers/LawController.php:13
* @route '/ochrana-osobnich-udaju'
*/
export const policy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: policy.url(options),
    method: 'get',
})

policy.definition = {
    methods: ["get","head"],
    url: '/ochrana-osobnich-udaju',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LawController::policy
* @see app/Http/Controllers/LawController.php:13
* @route '/ochrana-osobnich-udaju'
*/
policy.url = (options?: RouteQueryOptions) => {
    return policy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LawController::policy
* @see app/Http/Controllers/LawController.php:13
* @route '/ochrana-osobnich-udaju'
*/
policy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: policy.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LawController::policy
* @see app/Http/Controllers/LawController.php:13
* @route '/ochrana-osobnich-udaju'
*/
policy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: policy.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LawController::cookies
* @see app/Http/Controllers/LawController.php:22
* @route '/cookies'
*/
export const cookies = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookies.url(options),
    method: 'get',
})

cookies.definition = {
    methods: ["get","head"],
    url: '/cookies',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LawController::cookies
* @see app/Http/Controllers/LawController.php:22
* @route '/cookies'
*/
cookies.url = (options?: RouteQueryOptions) => {
    return cookies.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LawController::cookies
* @see app/Http/Controllers/LawController.php:22
* @route '/cookies'
*/
cookies.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: cookies.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LawController::cookies
* @see app/Http/Controllers/LawController.php:22
* @route '/cookies'
*/
cookies.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: cookies.url(options),
    method: 'head',
})

const LawController = { policy, cookies }

export default LawController